
import { FlatTransport } from '@/models/FlatTransport'
import { Transport } from '@/models/Transport'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import i18n from '@/i18n'
import Notification from '@/classes/Notification'
import axios from 'axios'
import { Model } from '@/models/Model'
import { createModelsFromResponse } from '@/utils/model'

@Component({
	components: {}
})
export default class CloseAllTransportsDialog extends Vue {
	@Prop({ required: false, default: false })
	opened!: boolean

	@Prop({ required: false, default: () => [] })
	transports!: Array<FlatTransport> | Array<Transport>

	isLoading: boolean = false
	closeDialog() {
		this.$emit('closed')
	}

	async closeTransports() {
		if (!this.transports.length) return

		try {
			this.isLoading = true

			const result = await axios.post(`${Model.baseUrl()}transports/close`, {
				data: this.transports.map((t) => {
					return {
						id: t.id,
						type: 'transports'
					}
				})
			})

			const models = createModelsFromResponse(FlatTransport, result.data)

			this.$emit('transportsClosed', models)
		} catch (err) {
			// eslint-disable-next-line
			console.error('Error occurred while closing the transports', err)
			await Notification.Error(i18n.t('errors.closing_transports').toString())
		} finally {
			this.isLoading = false
		}

		this.closeDialog()
	}
}
